import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';

export class IntegrationSavedSuccessWebView extends BaseWebComponentView {
  public dom: {
    $successTitle: HTMLElement;
    $successDescription: HTMLElement;
    $includedSensorsTitle: HTMLElement;
    $includedSensors: HTMLElement;
    $extraInfo: HTMLElement;
  };

  getDomElements() {
    this.dom = {
      $successTitle: this.shadow.querySelector('#success-title'),
      $successDescription: this.shadow.querySelector('#success-description'),
      $includedSensorsTitle: this.shadow.querySelector('#included-sensors-title'),
      $includedSensors: this.shadow.querySelector('#included-sensors'),
      $extraInfo: this.shadow.querySelector('#extra-info'),
    };
    this.getTranslations();
    this.setTranslatedStrings();
  }

  public setTranslatedStrings() {
    this.dom.$successTitle.innerText = this.dependencies.translateFn('Success');
  }

  getTranslations() {
    this.translations = this.stringsTranslator.getSensorsIntegrationsStrings();
    return this.translations;
  }

  buildView() {
    this.buildSuccessView();
  }

  buildSuccessView(): void {}
}
